import { post } from '../../helpers/axios'

export default async function approveCandidate(id) {
  const res = await post(`/starts/${id}/command/approve`)
  return res
}
